
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { AlertTriangle } from "lucide-react"

type VoteConfirmationModalProps = {
    open: boolean
    onConfirm: () => void
    onCancel: () => void
    pollTitle: string
    selectedOption: string
    optionType: 'yes' | 'no' | 'third'
}

export const VoteConfirmationModal = ({ 
    open, 
    onConfirm, 
    onCancel, 
    pollTitle, 
    selectedOption,
    optionType
}: VoteConfirmationModalProps) => {
    // Get the appropriate colors based on the option type
    const getOptionColors = () => {
        if (optionType === 'yes') {
            return {
                bg: 'bg-[#E5F4EA]',
                text: 'text-[#155231]',
                border: 'border-[#155231]',
                buttonBg: 'bg-[#E5F4EA]',
                buttonHover: 'hover:bg-[#D5E8DC]',
                buttonText: 'text-[#155231]'
            }
        } else if (optionType === 'no') {
            return {
                bg: 'bg-[#FFF7DE]',
                text: 'text-[#6F3B01]',
                border: 'border-[#6F3B01]',
                buttonBg: 'bg-[#FFF7DE]',
                buttonHover: 'hover:bg-[#FFE9B0]',
                buttonText: 'text-[#6F3B01]'
            }
        } else {
            return {
                bg: 'bg-[#EBF4FF]',
                text: 'text-[#1E40AF]',
                border: 'border-[#1E40AF]',
                buttonBg: 'bg-[#EBF4FF]',
                buttonHover: 'hover:bg-[#DBEAFE]',
                buttonText: 'text-[#1E40AF]'
            }
        }
    }

    const colors = getOptionColors()

    return (
        <Dialog open={open} onOpenChange={onCancel}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-lg font-semibold">Confirm Your Vote</DialogTitle>
                </DialogHeader>
                
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-gray-600 dark:text-gray-300">{pollTitle}</p>
                    </div>
                    
                    <div>
                        <h3 className="font-medium text-gray-900 dark:text-white mb-2">Your selection:</h3>
                        <div className={`px-3 py-2 rounded-md font-medium text-sm ${colors.bg} ${colors.text} border ${colors.border}`}>
                            {selectedOption}
                        </div>
                    </div>
                    
                    <div className="flex items-start gap-2">
                        <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
                        <p className="text-xs text-amber-700 dark:text-amber-300">
                            Once you vote, you cannot change your selection.
                        </p>
                    </div>
                </div>

                <DialogFooter className="mt-6 flex justify-end gap-2">
                    <Button variant="ghost" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={onConfirm}
                        className={`${colors.buttonBg} ${colors.buttonHover} ${colors.buttonText}`}
                    >
                        Confirm Vote
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
